import $ from 'jquery';
global.$ = global.jQuery = global.jquery = $;  // Use global instead of window in WebPack5

import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/collapse'; // required by dropdown
import 'bootstrap/js/dist/dropdown'; // would require @popperjs/core
import 'bootstrap/js/dist/index';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/util';
import 'popper.js'; // legacy popper.js required by Bootstrap js for some methods.

/** import external dependencies */

/** import local dependencies */
import moveClassesToBody from './UM-Base/lib/bodyClassMover';
import debugLogger from './UM-Base/lib/debugLogger';
import ComponentRouter from './UM-Base/util/ComponentRouter';
import Router from './UM-Base/util/Router';

// Import components
import Alerts from './UM-Base/components/Alerts';
import AnalyticsOdp from './UM-Base/components/AnalyticsOdp';
import BannerCarousel from './UM-Base/components/BannerCarousel';
import BlogLegend from './UM-Base/components/BlogLegend';
import Countdown from './UM-Base/components/Countdown';
import DataEvents from './UM-Base/components/DataEvents';
import DeviceResCookie from './UM-Base/components/DeviceResCookie';
import FooterLanguageLinks from './UM-Base/components/FooterLanguageLinks';
import Form from './UM-Base/components/Form';
import Header from './UM-Base/components/Header';
import HeaderSearch from './UM-Base/components/HeaderSearch';
import ImageParallax from './UM-Base/components/ImageParallax';
import ImageVideoCarouselWithSummary from './UM-Base/components/ImageVideoCarouselWithSummary';
import LazyImages from './UM-Base/components/LazyImages';
import ModalGallery from './UM-Base/components/ModalGallery';
import ModalIframe from './UM-Base/components/ModalIframe';
import ModalMessagebox from './UM-Base/components/ModalMessagebox';
import Overlay from './UM-Base/components/Overlay';
import PopOutBanner from './UM-Base/components/PopOutBanner';
import Product from './UM-Base/components/Product';
import ProductCalendar from './UM-Base/components/ProductCalendar';
import RelatedContent from './UM-Base/components/RelatedContent';
import ScrollComp from './UM-Base/components/ScrollComp';
import SearchBar from './UM-Base/components/SearchBar';
import SearchFilters from './UM-Base/components/SearchFilters';
import SearchMap from './UM-Base/components/SearchMap';
import SearchPredictive from './UM-Base/components/SearchPredictive';
import SearchSubmit from './UM-Base/components/SearchSubmit';
import ShareButton from './UM-Base/components/ShareButton';
import StickyNav from './UM-Base/components/StickyNav';
import SubMenu from './UM-Base/components/SubMenu';
import SupportVideo from './UM-Base/components/SupportVideo';
import TabbedContent from './UM-Base/components/TabbedContent';
import VimeoBanner from './UM-Base/components/VimeoBanner';

// Import routes
import blogSingle from './UM-Base/routes/blog-single';
import common from './REW/routes/common';
import search from './UM-Base/routes/search';
// import 'babel-polyfill';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  common,
  blogSingle,
  search,
});

/** Load Events */
$(() => {
  // Remove duplicate components and create component router instance
  const components = new ComponentRouter({
    Alerts,
    AnalyticsOdp,
    BannerCarousel,
    BlogLegend,
    Countdown,
    DataEvents,
    DeviceResCookie,
    FooterLanguageLinks,
    Form,
    Header,
    HeaderSearch,
    ImageParallax,
    ImageVideoCarouselWithSummary,
    LazyImages,
    ModalGallery,
    ModalIframe,
    ModalMessagebox,
    Overlay,
    PopOutBanner,
    Product,
    ProductCalendar,
    RelatedContent,
    ScrollComp,
    SearchBar,
    SearchFilters,
    SearchMap,
    SearchPredictive,
    SearchSubmit,
    ShareButton,
    StickyNav,
    SubMenu,
    SupportVideo,
    TabbedContent,
    VimeoBanner
  }, window.components.filter((value, index, self) => self.indexOf(value) === index));


  window.componentRouter = components;

  moveClassesToBody('.content-wrapper', ['content-wrapper']);

  debugLogger();

  components.registerComponents();
  routes.loadEvents(components);
  components.loadComponents();
});
